import { EventCategory } from '../EventCategory.model';
import eventCategories from '../eventCategories.json';
/**
 * Returns the event categories (with subcategories) filtered by `listAllIdsSupported`.
 * If there are EventIds not part of any category, they are added under an "others" category.
 * @param listAllIdsSupported - An array of strings representing all supported IDs of the workspace.
 */
export function getEventCategory(
  listAllIdsSupported: string[]
): EventCategory[] {
  const supportedSet = new Set(listAllIdsSupported);

  const allCategorizedIds = new Set<string>();
  eventCategories.forEach((category) => {
    category.eventIds.forEach((id) => allCategorizedIds.add(id));
  });

  const unsupportedEventIds = listAllIdsSupported.filter(
    (id) => !allCategorizedIds.has(id)
  );

  const filtered: EventCategory[] = eventCategories
    .map((category) => {
      const filteredSubCategories = category.subCategories
        .map((sub) => ({
          ...sub,
          eventIds: sub.eventIds.filter((id) => supportedSet.has(id)),
        }))
        .filter((sub) => sub.eventIds.length > 0);

      const filteredEventIds = category.eventIds.filter((id) =>
        supportedSet.has(id)
      );

      return {
        ...category,
        eventIds: filteredEventIds,
        subCategories: filteredSubCategories,
      };
    })
    .filter((category) => category.eventIds.length > 0);

  if (unsupportedEventIds.length > 0) {
    filtered.push({
      id: 'uncategorized',
      name_en: 'Uncategorized',
      eventIds: unsupportedEventIds,
      subCategories: [],
    });
  }

  return filtered;
}
